export const filters = {
  // 文字超出截断
  wordSlice(word, length) {
    if (!word || typeof value !== 'string') return word
    return word.length > length ? word.slice(0, length - 1) + '...' : word
  },

  // 分转元
  fen2yuan(value) {
    return !isNaN(value) ? (value / 100).toFixed(2) : value
  },
}

export default Vue => {
  Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
  })
}
